import style from './ContactSupport.module.scss'

export default function ContactSupport({
  blockType: _blockType,
  content: _content
}: {
  blockType: string
  content: string
}) {
  return (
    <div
      className={style.ContactSupport}
      role="button"
      tabIndex={0}
      onClick={() => {
        try {
          window.open(
            'https://static.zdassets.com/web_widget/latest/liveChat.html#key=aytm.zendesk.com',
            'AYTM_Support_Chat',
            'resizable=yes,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,height=500,width=400,top=500,left=600'
          )
        } catch {
          window.open('/resources/contact-us', '_blank', 'noopener,noreferrer')
        }
      }}
    >
      CONTACT SUPPORT
    </div>
  )
}
